import type { CommandStatus } from '../../context/CommandIssueContext';

export type StaticExecution = {
  tool: string;
  action: string;
  result: string;
  status: string;
};

export type ViewDetailsSeed = {
  id?: string;
  title?: string;
  status: CommandStatus;
  assigneeType?: number;
  description?: string;
};

export const toRunDetailStatus = (status: CommandStatus): 'done' | 'failed' | 'running' => {
  if (status === 'done') return 'done';
  return 'running';
};

export const getStaticExecutions = (seed: ViewDetailsSeed): StaticExecution[] => [
  {
    tool: 'intent_classifier_tool',
    action: JSON.stringify(
      {
        taskId: seed.id || 'preview-task',
        title: seed.title || 'Untitled Task',
        phase: 'intent-classification',
      },
      null,
      2,
    ),
    result: JSON.stringify({ intent: 'task_processing', confidence: 0.97, source: 'static-ui' }, null, 2),
    status: 'success',
  },
  {
    tool: 'workflow_router_tool',
    action: JSON.stringify(
      {
        status: seed.status,
        assigneeType: seed.assigneeType ?? 0,
        phase: 'routing',
      },
      null,
      2,
    ),
    result: JSON.stringify(
      {
        route: seed.status === 'done' ? 'completed-flow' : 'active-flow',
        source: 'static-ui',
      },
      null,
      2,
    ),
    status: 'success',
  },
  {
    tool: 'summary_writer_tool',
    action: JSON.stringify(
      {
        description: seed.description || 'No description provided',
        phase: 'summary',
      },
      null,
      2,
    ),
    result: 'Static execution detail view enabled. API calls are intentionally disabled for this screen.',
    status: 'success',
  },
];
